var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-bf-group"},[_c('div',{staticClass:"vue-bf-group-header"},[_vm._v(" group"+_vm._s(_vm.itemData.id)+" ")]),_c('div',{staticClass:"vue-bf-group-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }